/**
 * 把同一语言的多种写法 (zh / zh_hans / zh-CN / ja_JP / en_US) normalize 到一致 key,
 * 跨 desktop / 后端 / web 比对 lang 时统一用 normalized 值。
 *
 * - 简体中文家族: zh / zh_hans / zh_cn / zh_sg / zh-CN ... → 'zh'
 * - 繁体中文家族: zh_hant / zh_tw / zh_hk / zh_mo / zh-TW ... → 'zh_hant'
 * - 巴西葡语: pt_br / pt-BR → 'pt_br'(后端 SubtitleLangEnum 里 pt 与 pt_br 是两个独立翻译目标,
 *   不能和欧洲葡语 pt / pt_pt / pt-PT 合并,否则选择器分组、译文缓存、历史译文都会串)
 * - 其他: 取下划线/连字符前的第一段 (en_US → en, ja_JP → ja)
 */
const REGIONAL_TARGETS = new Set(['pt_br']);

export function normalizeLang(lang: string): string {
  const lower = lang.toLowerCase().replace(/-/g, '_');
  if (
    lower === 'zh'
    || lower === 'zh_hans'
    || lower === 'zh_cn'
    || lower === 'zh_sg'
  ) return 'zh';
  if (
    lower === 'zh_hant'
    || lower === 'zh_tw'
    || lower === 'zh_hk'
    || lower === 'zh_mo'
  ) return 'zh_hant';
  if (REGIONAL_TARGETS.has(lower)) return lower;
  return lower.split('_')[0];
}

/**
 * 两个语言码是否属于同一语言(原文已经是观众要看的语言,无需译文)。
 * 口径与后端 ShareHistoryTranslateComponentImpl.isSameLanguage 一致:
 * 中文按脚本区分(简↔繁不同),其它语言主语言相同即视为同语言
 * (pt-PT 原文对 pt_br 观众算同语言,后端也不会为这句推译文)。
 */
export function isSameLangFamily(a: string, b: string): boolean {
  const na = normalizeLang(a);
  const nb = normalizeLang(b);
  if (na === nb) return true;
  const pa = na.split('_')[0];
  const pb = nb.split('_')[0];
  if (pa !== pb) return false;
  return pa !== 'zh';
}
